import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autoBind from 'react-autobind';
import AvatarEditor from 'react-avatar-editor';
import Slider from 'ui/common/rebranding/components/Slider/Slider';
import 'ui/common/rebranding/components/Slider/styles.scss';
import { dataURLtoFile } from 'utils/dataURLtoFile';

class ImageEditor extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      scale: 0.25,
      position: { x: 0.5, y: 0.5 },
    };
  }

  handleSliderChange(e) {
    const scale = parseFloat(e.value);
    this.setState({
      scale,
    });
  }

  onPositionChange(position) {
    this.setState({ position });
  }

  setEditorRef(editor) {
    if (editor) {
      this.editor = editor;
    }
  }

  handleChange() {
    try {
      const base64 = this.editor.getImageScaledToCanvas().toDataURL();
      const file = dataURLtoFile(base64);
      this.props.onChange(file);
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    const { image, editorHeight, editorWidth, borderRadius } = this.props;
    return (
      <div>
        <AvatarEditor
          ref={this.setEditorRef}
          image={image}
          scale={this.state.scale}
          position={this.state.position}
          borderRadius={borderRadius}
          onPositionChange={this.onPositionChange}
          height={editorHeight}
          width={editorWidth}
          onMouseUp={this.handleChange}
          onImageReady={this.handleChange}
          color={[0, 0, 0, 0.8]}
          crossOrigin="anonymous"
        />
        <div className="pt-3" />
        <Slider
          id="slider"
          labelText="Use the slider to zoom and drag the image to adjust"
          min={0.25}
          max={3}
          step={0.01}
          value={1}
          onChange={this.handleSliderChange}
          onDragEnd={this.handleChange}
        />
      </div>
    );
  }
}

ImageEditor.propTypes = {
  image: PropTypes.string.isRequired,
  editorWidth: PropTypes.number,
  editorHeight: PropTypes.number,
  borderRadius: PropTypes.number,
  onLoadFailure: PropTypes.func,
  onLoadSuccess: PropTypes.func,
  onImageReady: PropTypes.func,
  onPositionChange: PropTypes.func,
  scale: PropTypes.number,
};

export default ImageEditor;



// WEBPACK FOOTER //
// ./src/ui/common/rebranding/components/ImageEditor/ImageEditor.js